<template>
  <zt-modal
    class="rounded font-normal"
    :title="$t('message.abm.folders.modals.cancelSubFolder.title')"
    @close="closeDialog" max-width="600px"
    :active="active"
    :z-index="1001"
  >
    <template>
      <div class="flex px-10 py-12">
        <div class="flex flex-none items-center w-24 h-24 justify-center mr-16">
          <zt-icon
            name="exclamation-circle-outline"
            class="text-zt-warning"
            :style="{ fontSize: '6rem'}"
          />
        </div>
        <div>
          <p class="text-zt-xl mb-4 text-zt-dark-500">
            {{ $t('message.abm.folders.modals.cancelSubFolder.label') }}
            <b v-if="folderName">{{ folderName }}</b>
            <span v-else>{{ $t('message.abm.folders.modals.cancelSubFolder.label1') }}</span>?
          </p>
          <p class="text-custom-legend text-zt-dark-400" v-if="withSubFolder">
            {{ $t('message.abm.folders.modals.cancelSubFolder.label2') }}
          </p>
          <p class="text-custom-legend text-zt-dark-400" v-else>
            {{ $t('message.abm.folders.modals.cancelSubFolder.label3') }}
          </p>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div
        class="zt-modal-footer rounded-b flex justify-end items-center p-4"
      >
        <zt-button
          text
          color="dark-300"
          class="button-cancel mr-4"
          @click="closeDialog"
          data-vs-button="closeDialog"
        >
          {{ $t('message.abm.folders.modals.cancelSubFolder.buttonSecondary') }}
        </zt-button>
        <zt-button
          class="w-25"
          @click="confirmLeave"
          data-vs-button="confirmLeave"
        >
          {{ $t('message.abm.folders.modals.cancelSubFolder.buttonPrimary') }}
        </zt-button>
      </div>
    </template>
  </zt-modal>
</template>

<script>
export default {
  name: 'CancelSubFolderDialog',
  inject: [ 'activeDialog', 'resetSubFolderParams' ],
  props: {
    active: {
      type: Boolean,
      default: false
    },
    folderName: {
      type: String,
      default: ''
    },
    withSubFolder: {
      type: Boolean,
      default: false
    },
    isLeave: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeDialog() {
      this.activeDialog(false)
    },
    async confirmLeave() {
      if (this.isLeave) {
        this.$emit('confirm-leave', true)
      } else {
        await this.resetSubFolderParams()
        if (!this.withSubFolder) {
          this.$router.push('/folder')
          return
        }
        this.$router.push({
          id: this.$route.params.id,
          name: 'subfolder',
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.zt-modal-footer {
  background-color: #EEEEEE;
}
.text-custom-legend {
  font-size: 1.125rem;
}
::v-deep {
  .zt-modal {
    box-shadow: 0 3px 4px rgba(0, 0, 0, 0.14), 0 3px 3px rgba(0, 0, 0, 0.12),
    0 1px 8px rgba(0, 0, 0, 0.2);
  }
  .zt-modal.rounded {
    border-radius: .375rem!important;
  }
  button.button-cancel {
    color: #707070!important;
    background-color: transparent!important;
  }
}
</style>
